export type InAppFeedbackStatus = "new" | "investigating" | "in_progress" | "resolved"
export type InAppFeedbackSentiment = "had_issues" | "good"

export interface InAppFeedbackFeature {
  id: number
  slug: string
  name: string
  sortOrder: number
  categories: string[]
}

export interface InAppFeedbackIssue {
  id: number
  featureId: number
  category: string
  slug: string
  title: string
  status: InAppFeedbackStatus
  sortOrder: number
  createdAt: string
  updatedAt: string
}

export interface InAppFeedbackIssueCount extends InAppFeedbackIssue {
  count: number
}

export interface InAppFeedbackDailyCount {
  date: string
  count: number
}

export interface InAppFeedbackDailySentiment {
  date: string
  submissions: number
  hadIssues: number
  good: number
}

export interface InAppFeedbackSubmission {
  id: number
  featureId: number
  issueId?: number
  sentiment: InAppFeedbackSentiment
  reporterRef: string
  occurredAt: string
  context: Record<string, unknown>
}

export interface InAppFeedbackCatalogCategory {
  slug: string
  name: string
  issues: InAppFeedbackIssue[]
}

export interface InAppFeedbackCatalogFeature {
  slug: string
  name: string
  categories: InAppFeedbackCatalogCategory[]
}

export interface InAppFeedbackCatalog {
  features: InAppFeedbackCatalogFeature[]
}

export interface InAppFeedbackTotals {
  submissions: number
  hadIssues: number
  good: number
}

export interface InAppFeedbackOverview {
  feature: string
  from: string
  to: string
  totals: InAppFeedbackTotals
  daily: InAppFeedbackDailySentiment[]
  issues: InAppFeedbackIssueCount[]
}

export const inAppFeedbackCategoryLabel = (slug: string): string => {
  if (slug === "screenshare") {
    return "Screenshare"
  }
  if (!slug) {
    return slug
  }
  return slug.charAt(0).toUpperCase() + slug.slice(1)
}

export interface InAppFeedbackIssueDetail {
  issue: InAppFeedbackIssue
  count: number
  daily: InAppFeedbackDailyCount[]
  recent: InAppFeedbackSubmission[]
}

export const inAppFeedbackStatusLabel = (status: InAppFeedbackStatus): string => {
  switch (status) {
    case "new":
      return "New"
    case "investigating":
      return "Investigating"
    case "in_progress":
      return "In Progress"
    case "resolved":
      return "Resolved"
    default:
      return status
  }
}
